import TheViewInnerHero from '@helpers/TheViewInnerHero.class';

const element = document.querySelector<HTMLElement>('.kf-o-the-view-inner-hero');

if (element) {
  const instance = new TheViewInnerHero(element);

  instance.init();
}

export {};
